import { useNavigate } from "react-router-dom";
import { useProfile, moduleEnabled } from "@/context/BusinessProfileContext";
import { WORKSHOP_TABS } from "@/pages/Workshop";

export default function WorkshopShortcuts({ apptId }) {
  const navigate = useNavigate();
  const { modules } = useProfile();
  if (!apptId || !moduleEnabled(modules, "detailing_tools")) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="appt-workshop-shortcuts">
      <div className="text-xs font-semibold text-slate-600 mb-2">Dossier atelier du RDV</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-3 2xl:grid-cols-4 gap-2">
        {WORKSHOP_TABS.map((t) => (
          <button key={t.key} type="button" data-testid={`appt-ws-${t.key}`} onClick={() => navigate(`/rdv/${apptId}/atelier?tab=${t.key}&from=appt`)}
            className="flex items-center gap-2 rounded-lg bg-white border border-slate-200 px-3 py-2.5 text-xs font-medium text-slate-700 hover:border-emerald-300 hover:text-emerald-700 transition-colors">
            <t.icon className="w-4 h-4 shrink-0" /><span className="min-w-0 leading-tight text-left">{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
